import { Injectable, NgZone } from '@angular/core';
import { SaveExecutionOfflineService } from './saveExecutionOffline.service';
import { DexieService } from './dexieService';
import { SnackBarService } from './snackBar.service';
import { SpinnerService } from './spinner.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { OnlineService } from './online.service';


@Injectable({
  providedIn: 'root'
})
export class OnlineSyncService {
  private syncing = false;
  private destroy$ = new Subject<void>();

  constructor(
    private ngZone: NgZone,
    private saveOffline: SaveExecutionOfflineService,
    private dexieService: DexieService,
    private snackbar: SnackBarService,
    private spinner: SpinnerService,
    private translate: TranslateService,
    private onlineService: OnlineService,
  ) {
  }

  initSyncListener(): void {
    this.onlineService.online$.subscribe(async (status) => {
      console.log('Conexión detectada:', status ? 'ONLINE' : 'OFFLINE');

      if (status) {
        await this.handleOnline();
      }
    });
  }

  private async handleOnline() {
    if (this.syncing) return;
    this.syncing = true;

    try {
      const pendingChanges = await this.dexieService.changes.filter(c => !c.deleted).count();
      const pendingAttachments = await this.dexieService.attached.filter(a => !a.deleted).count();

      if (pendingChanges > 0 || pendingAttachments > 0) {
        this.ngZone.run(() => this.spinner.show());

        await this.saveOffline.saveOfflineChanges();
        await this.saveOffline.deleteCacheDixie();

        this.snackbar.sendSuccess(this.translate.instant('executionEdit.form.saveOffline.ok'));
        this.snackbar.sendWarn(this.translate.instant('executionEdit.form.saveOffline.warning'));
      }
    } catch (error) {
      console.error('Error al sincronizar offline:', error);
      this.snackbar.sendError('Error al sincronizar los datos offline.');
    } finally {
      this.ngZone.run(() => this.spinner.hide());
      this.syncing = false;
    }
  }

  destroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
